export enum BatchStatus {
  NEW_BATCH = 100100,
  ASSEMBLING_READINGS = 200200,
  IN_PROGRESS = 400400,
  COMPLETE = 500500,
  TERMINATED = 600600
}
